import accountsInactive from '../../core/assets/sideNav/icons/account-managment-inactive.svg'
import accountsActive from '../../core/assets/sideNav/icons/account-managment-active.svg'
import appointmentsInactive from '../../core/assets/sideNav/icons/appointments-inactive.svg'
import appointmentsActive from '../../core/assets/sideNav/icons/appointments-active.svg'
import calculatorInactive from '../../core/assets/sideNav/icons/calculator-inactive.svg'
import calculatorActive from '../../core/assets/sideNav/icons/calculator-active.svg'
import collateralInactive from '../../core/assets/sideNav/icons/collateral-inactive.svg'
import collateralActive from '../../core/assets/sideNav/icons/collateral-active.svg'
import clientCenterInactive from '../../core/assets/sideNav/icons/my-client-center-inactive.svg'
import clientCenterActive from '../../core/assets/sideNav/icons/my-client-center-active.svg'
import productShowcaseInactive from '../../core/assets/sideNav/icons/product-showcase-inactive.svg'
import productShowcaseActive from '../../core/assets/sideNav/icons/product-showcase-active.svg'
import proposalToolInactive from '../../core/assets/sideNav/icons/proposal-tool-inactive.svg'
import proposalToolActive from '../../core/assets/sideNav/icons/proposal-tool-active.svg'
import purchaseLinkInactive from '../../core/assets/sideNav/icons/purchase-link-inactive.svg'
import purchaseLinkActive from '../../core/assets/sideNav/icons/purchase-link-active.svg'
import reportsInactive from '../../core/assets/sideNav/icons/reports-inactive.svg'
import reportsActive from '../../core/assets/sideNav/icons/reports-active.svg'

// Figma icons: outline (inactive) / filled (active). The per-state files in
// core/assets/sideNav/icons are split out of the two-icon sprites in
// core/assets/sideNav/*.svg. Items without an entry here fall back to a
// single legacy `icon`.
export const NAV_ICONS = {
  accounts: {icon: accountsInactive, activeIcon: accountsActive},
  appointments: {icon: appointmentsInactive, activeIcon: appointmentsActive},
  productShowcase: {
    icon: productShowcaseInactive,
    activeIcon: productShowcaseActive,
  },
  collateral: {icon: collateralInactive, activeIcon: collateralActive},
  calculator: {icon: calculatorInactive, activeIcon: calculatorActive},
  clientCenter: {icon: clientCenterInactive, activeIcon: clientCenterActive},
  purchaseLinks: {icon: purchaseLinkInactive, activeIcon: purchaseLinkActive},
  reports: {icon: reportsInactive, activeIcon: reportsActive},
  proposalTool: {icon: proposalToolInactive, activeIcon: proposalToolActive},
}
